// extracted by mini-css-extract-plugin
export default {"right_article":"index_right_article_kH3nF","first_item":"index_first_item_l89LX","item":"index_item_LAmYk","check_more":"index_check_more_KKmvn","assess":"index_assess_GUZW4"};